import React, { useRef, useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Stage, Layer, Text, Rect, Image as KonvaImage, Circle } from "react-konva";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ChaseFloorPLan from "../../../assets/ChaseFloorPlan.png";
import Thrivecity from "../../../assets/Thrivecity.png";
import styled from "styled-components";
import { Icon } from "@vds/icons";
import { ButtonGroup } from "@vds/buttons";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
//import AlertIcon from "../../../assets/alert.svg"
import AlertInWhite from "../../../assets/alertWhite.svg";
import DashboardEventRow from "../events/DashboardEventRow.jsx";

import { TimeOfEvent, NameOfTheEvent, SummaryofEvent, CameraNameofEvent } from "../events/styles.jsx";
import ShareEvents from "../Modals/ShareEvents.jsx";
import { useNavigate } from "react-router-dom";
import { getCameraLocationForGivenID } from "../../../model/reportService.js";
import Draggable from "react-draggable";
import GmtToLocal from "../../utility/GmtToLocal.js";
import { getEventDescription } from "../../utility/incidentsUtils.js";
import { setDeviceNameEndPoint } from "../../../configuration.js";
import { getRandomUUID } from "../../../Token.js";
import {
  ImageContainer,
  Container,
  Button,
  ImageStyle,
  MapControls,
  Expand,
  MarkerStyle,
  CriticalMarkerStyle,
  CustomTooltip,
  EditIconForFP,
  TickIconForFP,
  CloseIconForFP,
  ZoomButtonsBox,
  Edit
} from "./styles.jsx";
import { filterCameraListBasedOnTag, getEventsIconOnPriorityTile } from "../../../model/DashboardFilterService.js";
import { EVENT_STATUS, SEVERITY_LEVELS } from "../../constants/constants.js";
import { getIncidentsData } from "../../utility/Utils.js";
import floorPlanCameraIcon from "../../../assets/floorPlanCameraIcon.svg";
import { Loader } from "@vds/loaders";
import CameraIconEBC from "../../../assets/EventIconsEBC/camera-icon.svg";

//new icons which are required for EBC
//import criticalDwellTime from "../../src/assets/EventIconsEBC/Orange/dwell-time.svg";
//import criticalObjectDetection from "../../src/assets/EventIconsEBC/Orange/object-detection.svg";
import criticalOpenDoor from "../../../assets/EventIconsEBC/Orange/open-door.svg";
import criticalPeopleCount from "../../../assets/EventIconsEBC/Orange/people-count.svg";
import criticalRestrictedArea from "../../../assets/EventIconsEBC/Orange/restricted-area.svg";
import criticalSlipAndFall from "../../../assets/EventIconsEBC/Orange/slip-and-fall.svg";
import criticalPhoneDetection from "../../../assets/EventIconsEBC/Orange/phone-detected-orange-lg.svg";
import criticalIntrusionDetection from "../../../assets/EventIconsEBC/Orange/restricted-area-orange-lg.svg";

import minorOpenDoor from "../../../assets/EventIconsEBC/Blue/open-door.svg";
import minorPeopleCount from "../../../assets/EventIconsEBC/Blue/people-count.svg";
import minorSlipAndFall from "../../../assets/EventIconsEBC/Blue/slip-and-fall.svg";
import minorPhoneDetection from "../../../assets/EventIconsEBC/Blue/phone-detected-blue.svg";
import minorIntrusionDetection from "../../../assets/EventIconsEBC/Blue/restricted-area-blue.svg";

import fireBlue from "../../../assets/EventIcons/Blue/fire.svg";
import fireOrange from "../../../assets/EventIcons/Orange/fire.svg";
import axiosInstance from "../../axiosInterceptor";
import { getImageObj } from "../../utility/Utils.js";
import { ROUTES } from "../../constants/routesConstants.js";

// Constants for floor plan configuration
const FLOOR_PLAN_CONSTANTS = {
  // Screen dimensions multipliers
  SCREEN_WIDTH_MULTIPLIER: 0.5,
  SCREEN_HEIGHT_MULTIPLIER: 0.5,
  FULLSCREEN_WIDTH_MULTIPLIER: 0.8,
  FULLSCREEN_HEIGHT_MULTIPLIER: 0.8,

  // Default dimensions
  DEFAULT_WIDGET_WIDTH: 595,
  DEFAULT_WIDGET_HEIGHT: 295,
  DEFAULT_STAGE_WIDTH: 730,
  DEFAULT_STAGE_HEIGHT: 525,

  // Camera and marker settings
  DEFAULT_CAMERA_SIZE: 50,
  DEFAULT_MARKER_POSITION: 50,
  DEFAULT_POSITION_X: 150,
  DEFAULT_POSITION_Y: 150,

  // Scaling and positioning
  BASE_WIDTH_RATIO: 464,
  BASE_HEIGHT_RATIO: 332,
  FULLSCREEN_POSITION_OFFSET_X: 25,
  FULLSCREEN_POSITION_OFFSET_Y: 25,
  SCREENMODE_POSITION_OFFSET_X: 50,
  SCREENMODE_POSITION_OFFSET_Y: 30,

  // Zoom settings
  ZOOM_IN_FACTOR: 1.2,
  ZOOM_OUT_FACTOR: 0.8,
  SCALE_FACTOR_LARGE: 1.2,
  SCALE_FACTOR_NORMAL: 1,

  // UI positioning
  TOOLTIP_OFFSET_X: 10,
  TOOLTIP_OFFSET_Y: 10,
  CLOSE_BUTTON_TOP: 10,
  CLOSE_BUTTON_RIGHT: 10,
  CLOSE_BUTTON_SIZE: 40,
  CLOSE_BUTTON_FONT_SIZE: 20,

  // Modal positioning
  MODAL_TOP_PERCENT: 5,
  MODAL_SIDE_PERCENT: 5,
  MODAL_WIDTH_PERCENT: 82,
  MODAL_HEIGHT_PERCENT: 82,
  MODAL_PADDING: 20,
  MODAL_BUTTON_RIGHT: 25,
  MODAL_BUTTON_TOP: 25,
  MODAL_BUTTON_BOTTOM: 15,

  // Background adjustments
  BACKGROUND_SIZE_ADJUSTMENT: 10,

  // Tooltip styling
  TOOLTIP_PADDING: 5,
  TOOLTIP_FONT_SIZE: 12,
  TOOLTIP_BORDER_RADIUS: 4,

  // Z-index values
  Z_INDEX_MODAL: 9999,
  Z_INDEX_CLOSE_BUTTON: 10000,

  // Shadow and styling
  BOX_SHADOW_BLUR: 8,
  BOX_SHADOW_OPACITY: 0.2,

  // Camera info padding
  CAMERA_INFO_PADDING: 20
};

// Custom hook to load an image
const useImages = (url) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    const img = new window.Image();
    img.src = url;
    img.onload = () => {
      setImage(img);
    };
  }, [url]);

  return image;
};
const FloorPlan = ({
  cameras,
  showHazard,
  widgetSize,
  isEditable,
  floorImage,
  floorId,
  selectedFloorImage,
  dashboard,
  imageLoading,
  containerHeight,
  applicationId,
  severity,
  FloorSize,
  eventData,
  top,
  left,
  altLayout,
  iscamInfo,
  cameraId,
  unresolvedEventData,
  eventCheck,
  fitToContainer
}) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const criticalEvents = useSelector((state) => state.eventReducer.criticalEvents);
  const allCameraList = useSelector((state) => state.deviceReducer.cameraList);
  const sourceId = useSelector((state) => state.eventReducer.sourceId);
  const eventNameFetched = useSelector((state) => state.eventReducer.evidence);
  const allEventsData = useSelector((state) => state.eventReducer.criticalUnresolved);
  const incidentsByFloor = useSelector((state) => state.eventReducer.incidentsByFloor?.data);
  const incidentsByFloorLoading = useSelector((state) => state.eventReducer.incidentsByFloor.loading);
  const cvAppsFromReducer = useSelector(
    (state) => state.cvAppReducer.cvAppList
  );
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  const [showShareEvents, setShowShareEvents] = useState({ isOpen: false });
  const [criticalEventsData, setCriticalEventsData] = useState([]);
  const [eventsallData, seteventsData] = useState([]);
  const [eventIds, setEventIds] = useState([]);
  const [availableVideoEvidence, setAvailableVideoEvidence] = useState([]);
  const [evidenceVideoUrl, setEvidenceVideoUrl] = useState(null);
  const [videoEvidences, setVideoEvidences] = useState([]);
  const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [updatedPosition, setUpdatedPosition] = useState({});
  const [initialMarkers, setInitialMarkers] = useState([]);
  const [evidanceSourceId, setEvidanceSourceId] = useState(null);
  const [cameraEventsMap, setCameraEventsMap] = useState({});
  const cameraEventsMapCache = useRef(new Map()); // Map<floorId, cameraEventsMap>
  const prevFloorIdRef = useRef(null);
  const prevIncidentsByFloorRef = useRef(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: ""
  });

  //Responsive the width
  const FloorWidth = window.innerWidth * FLOOR_PLAN_CONSTANTS.SCREEN_WIDTH_MULTIPLIER;
  const FloorHeight = window.innerHeight * FLOOR_PLAN_CONSTANTS.SCREEN_HEIGHT_MULTIPLIER;
  const [originalWidth, orginalHeight] = FloorSize
    ? FloorSize
    : widgetSize
      ? [FLOOR_PLAN_CONSTANTS.DEFAULT_WIDGET_WIDTH, FLOOR_PLAN_CONSTANTS.DEFAULT_WIDGET_HEIGHT]
      : [FLOOR_PLAN_CONSTANTS.DEFAULT_STAGE_WIDTH, FLOOR_PLAN_CONSTANTS.DEFAULT_STAGE_HEIGHT];
  let stageWidth = originalWidth ? originalWidth : FLOOR_PLAN_CONSTANTS.DEFAULT_STAGE_WIDTH;
  let stageHeight = orginalHeight ? orginalHeight : FLOOR_PLAN_CONSTANTS.DEFAULT_STAGE_HEIGHT;
  const [scale, SetScale] = useState(1);
  const stageRef = useRef(null);

  // Initial sizes
  const initialBackgroundSize = { width: stageWidth, height: stageHeight };
  const initialForegroundSize = { width: FLOOR_PLAN_CONSTANTS.DEFAULT_CAMERA_SIZE, height: FLOOR_PLAN_CONSTANTS.DEFAULT_CAMERA_SIZE };
  const [fullScreen, setFullScreen] = useState(false);
  // const [screenStatus, setScreenStatus] = useState(false);
  var screenStatus = false;
  var screenmode = false;

  // State for background and foreground images
  const [backgroundSize, setBackgroundSize] = useState(initialBackgroundSize);
  const [foregroundSize, setForegroundSize] = useState(initialForegroundSize);

  // State for foreground image position
  const [position, setPosition] = useState({
    x: FLOOR_PLAN_CONSTANTS.DEFAULT_POSITION_X,
    y: FLOOR_PLAN_CONSTANTS.DEFAULT_POSITION_Y
  });

  const backgroundImage = useImages(floorImage);
  // console.log(floorImage,backgroundImage, "backgroundImage >>>")
  const foregroundImage = useImages(CameraIconEBC);
  const criticalId = useImages(criticalIntrusionDetection);
  const minorId = useImages(minorIntrusionDetection);
  const criticalOd = useImages(criticalOpenDoor);
  const minorOd = useImages(minorOpenDoor);
  const criticalSf = useImages(criticalSlipAndFall);
  const minorSf = useImages(minorSlipAndFall);
  const fireO = useImages(fireOrange);
  const fireB = useImages(fireBlue);
  const criticalPd = useImages(criticalPhoneDetection);
  const minorPd = useImages(minorPhoneDetection);
  const criticalPc = useImages(criticalPeopleCount);
  const minorPc = useImages(minorPeopleCount);
  const konvaElementRef = useRef();

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [iconPosition, setIconPosition] = useState({ x: 0, y: 0 });
  const [tooltipText, setTooltipText] = useState("");
  const textRef = useRef();
  // Stores the setTimeout ID from handleMouseEnter so all onMouseLeave
  // handlers can cancel it before it fires. Without this, a race condition causes the tooltip
  // to get stuck visible permanently: mouseLeave fires synchronously → sets tooltipVisible=false,
  // then the deferred setTimeout fires → overrides back to true → tooltip stuck over icon → blocks clicks.
  const tooltipTimerRef = useRef(null);
  const [textSize, setTextSize] = useState({ width: 0, height: 0 });

  const [modalPopupFullscreen, setModalPopupFullscreen] = useState(false);
  const modalPopupFullscreenRef = useRef(false);
  useEffect(() => { modalPopupFullscreenRef.current = modalPopupFullscreen; }, [modalPopupFullscreen]);


  useEffect(() => {
    if (allEventsData && allEventsData.length > 0) {
      let allEventsDataourceIds = [];
      const sortedEventList = allEventsData;
      const mappedData = sortedEventList
        .map((event) => {
          if (event && event.hasOwnProperty("evidences")) {
            allEventsDataourceIds.push(event?.evidences[0]?.sourceId || cameraId);
            const cvAppList = cvAppsFromReducer;
            const findAppName = cvAppList?.filter((cvApp) => cvApp?.image === event.applicationId);
            const appName = findAppName?.length ? findAppName[0]?.name : "";
            return {
              timeOfEvent: event.createdAt,
              nameOfEvent: appName === "IntrusionDetection" ? "Restricted Area" : appName,
              summaryOfEvent: getEventDescription(event?.applicationId, event?.deviceLoc, event?.description),
              cameraId: event?.evidences[0]?.sourceId || cameraId,
              priority: event?.priority,
              videoEvidences: event?.evidences[0]?.id,
              status: event?.status,
              createdAt: event?.createdAt,
              description: event?.description,
              updatedAt: event?.updatedAt,
              id: event?.id,
              custom: event?.eventObjectDetail,
              incidentNumber: event?.incidentNumber,
              deviceLoc: event?.deviceLoc,
              evidences: event?.evidences,
              applicationId: event?.applicationId,
              evidenceStatus: event?.evidenceStatus ?? null,
              type: event?.type ?? "Incident",
              fovId: Array.isArray(event?.evidences) && event?.evidences?.length > 0 ? event?.evidences[0]?.fovId : null
            };
          }
          return null;
        })
        .filter((event) => event !== null); // Ensure we filter out null values
      setEventIds(allEventsDataourceIds);
      seteventsData(mappedData);
      setVideoEvidences(allEventsData[0]?.evidences?.filter((evidence) => evidence.mediaType === "video"));
    }
  }, [allEventsData]);

  //  Generate camera dependency key in format qrcode:top,left
  const getCameraDependencyKey = (cameras) => {
    return cameras?.map(camera =>
      `${camera.qrcode}:${camera.customdata?.cameralocation?.top},${camera.customdata?.cameralocation?.left}`
    ).join('|') || '';
  };

  // Extract qrcodes and camera locations as a single dependency key
  const cameraDependencyKey = useMemo(() => {
    return getCameraDependencyKey(cameras);
  }, [cameras]);

  const cameraList = useMemo(() => {
    if (cameras && cameras.length > 0) {
      return filterCameraListBasedOnTag(cameras, floorId);
    }
  }, [cameraDependencyKey, floorId]);

  const [markers, setMarkers] = useState([]);

  // Process incidents by floor data and map to cameras
  useEffect(() => {
    const floorChanged = prevFloorIdRef.current !== floorId;
    const dataChanged = prevIncidentsByFloorRef.current !== incidentsByFloor;

    // Skip only during a pure background refresh: same floor, same data, still loading
    if (incidentsByFloorLoading && !floorChanged && !dataChanged) return;

    prevFloorIdRef.current = floorId;
    prevIncidentsByFloorRef.current = incidentsByFloor;

    if (!cameraList || cameraList.length === 0 || !activeSession?.accountId || !incidentsByFloor) {
      setCameraEventsMap(
        floorId && cameraEventsMapCache.current.has(floorId)
          ? cameraEventsMapCache.current.get(floorId)
          : {}
      );
      return;
    }

    const newEventsMap = {};

    // Loop through camera list
    cameraList.forEach((camera) => {
      // Get all floors from the response (first level keys are floor IDs)
      Object.keys(incidentsByFloor).forEach((responseFloorId) => {
        const floor = incidentsByFloor[responseFloorId];

        // Check if this floor contains the camera ID
        if (floor[camera.id]) {
          const cameraData = floor[camera.id];
          const appDetails = cameraData.appDetails;
          const totalCount = cameraData.totalCount;

          // Store each app from appDetails as a separate key in the object
          if (appDetails) {
            Object.keys(appDetails).forEach((appName) => {
              if (!newEventsMap[camera.id]) {
                newEventsMap[camera.id] = []
              }

              newEventsMap[camera.id].push({
                cameraId: camera.id,
                count: appDetails[appName],
                applicationId: appName,
                priority: SEVERITY_LEVELS.CRITICAL,
                status: EVENT_STATUS.UNRESOLVED,
                total: totalCount
              });
            });
          }
        }
      });
    });

    if (Object.keys(newEventsMap).length > 0) {
      cameraEventsMapCache.current.set(floorId, newEventsMap);
      setCameraEventsMap(newEventsMap);
    } else if (floorId && cameraEventsMapCache.current.has(floorId)) {
      setCameraEventsMap(cameraEventsMapCache.current.get(floorId));
    } else {
      setCameraEventsMap({});
    }
  }, [cameraList, floorId, activeSession, incidentsByFloor, incidentsByFloorLoading]);

  const renderCountBadge = (markerId, markerTop, markerLeft, appId, isHovered) => {
    const markerEvents = cameraEventsMap[markerId];
    const fallbackTotal = markerEvents?.[0]?.total;

    const appSpecificEvent = markerEvents?.find(event => event.applicationId === appId);

    const count = appSpecificEvent?.count ?? fallbackTotal;
    const totalCount = appSpecificEvent?.total ?? fallbackTotal;

    const activeCount = isHovered ? count : totalCount;

    if (!activeCount) return null;
    const radius = 9;
    const x = markerTop + foregroundSize.width - radius;
    const y = markerLeft + radius - 4;
    return (
      <>
        <Circle x={x} y={y} radius={radius} fill="#FFD700" listening={false} />
        <Text
          x={x - radius}
          y={y - 3}
          width={radius * 2}
          text={activeCount > 99 ? "99+" : String(activeCount)}
          fontSize={7}
          fontFamily="Verizon NHG eTX"
          fill="#000000"
          align="center"
          listening={false}
        />
      </>
    );
  };

  const konvaJsContext = document.getElementsByClassName("konvajs-content")?.[0];

  useEffect(() => {
    setEvidanceSourceId(sourceId);
  }, [sourceId]);


  useEffect(() => {
    if (tooltipVisible && textRef.current && stageRef?.current) {
      requestAnimationFrame(() => {
        const rect = textRef?.current?.getClientRect();
        const scale = stageRef?.current?.scaleX();

        setTextSize({
          width: rect?.width / scale,
          height: rect?.height / scale
        });
      });
    }
  }, [tooltipVisible, tooltipText]);

  const pixelRatio = window.devicePixelRatio || 1;

  useEffect(() => {
    if (!stageRef.current || !backgroundImage) return;

    const resizeStage = () => {
      const container = stageRef?.current?.container();
      const width = container?.offsetWidth;
      const height = container?.offsetHeight;

      // Skip if container doesn't have valid dimensions yet
      if (!width || !height) {
        return;
      }

      stageRef?.current?.width(width);
      stageRef?.current?.height(height);

      // fitToContainer: zoom out so the full floor plan is visible within the container.
      // Only enabled when explicitly passed (EventsInfo page). Dashboard keeps scale 1.
      // Skip when fullscreen modal is open — modal manages its own scale (always 1).
      if (fitToContainer && !modalPopupFullscreenRef.current) {
        const fitScaleX = width / stageWidth;
        const fitScaleY = height / stageHeight;
        const fitScale = Math.min(fitScaleX, fitScaleY, 1);
        stageRef?.current?.scale({ x: fitScale, y: fitScale });
        SetScale(fitScale);
      } else if (!fitToContainer) {
        stageRef?.current?.scale({ x: 1, y: 1 });
      }
      stageRef?.current?.batchDraw();
    };

    // Wait for image to load before resizing
    if (backgroundImage.complete) {
      // Image already loaded - use rAF to wait for layout to settle
      let rafId = requestAnimationFrame(() => {
        rafId = requestAnimationFrame(() => {
          resizeStage();
        });
      });

      window.addEventListener("resize", resizeStage);
      return () => {
        cancelAnimationFrame(rafId);
        window.removeEventListener("resize", resizeStage);
      };
    } else {
      // Wait for image to load
      const handleImageLoad = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            resizeStage();
          });
        });
      };

      backgroundImage.addEventListener('load', handleImageLoad);
      window.addEventListener("resize", resizeStage);

      return () => {
        backgroundImage.removeEventListener('load', handleImageLoad);
        window.removeEventListener("resize", resizeStage);
      };
    }
  }, [backgroundImage, floorId]);

  useEffect(() => {
    const resizeStage = () => {
      const w = modalPopupFullscreen ? window.innerWidth * FLOOR_PLAN_CONSTANTS.FULLSCREEN_WIDTH_MULTIPLIER : originalWidth;
      const h = modalPopupFullscreen ? window.innerHeight * FLOOR_PLAN_CONSTANTS.FULLSCREEN_HEIGHT_MULTIPLIER : orginalHeight;
      // setStageWidth(w);
      // setStageHeight(h);
      setBackgroundSize({ width: w, height: h });

      const stage = stageRef.current;
      if (stage) {
        stage.width(w);
        stage.height(h);
        stage.batchDraw();
      }
    };
    resizeStage();
    window.addEventListener("resize", resizeStage);
    return () => window.removeEventListener("resize", resizeStage);
  }, [modalPopupFullscreen, originalWidth, orginalHeight]);

  const handleResize = (newWidth, newHeight, TopX, LeftY) => {
    // Calculate the scaling ratio for the background
    const widthRatio = newWidth / FLOOR_PLAN_CONSTANTS.BASE_WIDTH_RATIO;
    const heightRatio = newHeight / FLOOR_PLAN_CONSTANTS.BASE_HEIGHT_RATIO;

    // Recalculate foreground positions based on the background scaling
    const newX = TopX === 0 ?  FLOOR_PLAN_CONSTANTS.DEFAULT_MARKER_POSITION * widthRatio : TopX * widthRatio;
    const newY = LeftY === 0 ?  FLOOR_PLAN_CONSTANTS.DEFAULT_MARKER_POSITION * heightRatio : LeftY * heightRatio;

    // Update states
    return {
      x: modalPopupFullscreen ? newX + FLOOR_PLAN_CONSTANTS.FULLSCREEN_POSITION_OFFSET_X : newX,
      y: modalPopupFullscreen ? newY + FLOOR_PLAN_CONSTANTS.FULLSCREEN_POSITION_OFFSET_Y : newY
    };
  };

  const handlePosition = (width, height, floorId) => {
    let cameraList = cameras?.length > 0 ? filterCameraListBasedOnTag(cameras, floorId) : [];
    if (cameraList && cameraList?.length > 0) {
      const newWidth = modalPopupFullscreen ? window.innerWidth * FLOOR_PLAN_CONSTANTS.FULLSCREEN_WIDTH_MULTIPLIER : width;
      const newHeight = modalPopupFullscreen ? window.innerHeight * FLOOR_PLAN_CONSTANTS.FULLSCREEN_HEIGHT_MULTIPLIER : height;

      const initialMarkers = cameraList.map((camera, index) => ({
        top:
          handleResize(newWidth, newHeight, top ? top : camera.customdata?.cameralocation?.top, left ? left : camera.customdata?.cameralocation?.left)?.x ||
          FLOOR_PLAN_CONSTANTS.DEFAULT_MARKER_POSITION,
        left:
          handleResize(newWidth, newHeight, top ? top : camera.customdata?.cameralocation?.top, left ? left : camera.customdata?.cameralocation?.left)?.y ||
          FLOOR_PLAN_CONSTANTS.DEFAULT_MARKER_POSITION,
        data: camera.name,
        id: camera.id
      }));

      setMarkers(initialMarkers);
      setInitialMarkers(initialMarkers); // Store initial positions
      return initialMarkers;
    } else if (top && left) {
      const cameraUnavailable = [{
        top: top,
        left: left,
        data: "Camera Unavailable",
        id: cameraId
      }];
      setMarkers(cameraUnavailable);
      return cameraUnavailable;
    } else {
      setMarkers([]);
      return [];
    }
  };

  useEffect(() => {
    if (konvaJsContext) {
      if (konvaJsContext.parentElement) {
        konvaJsContext.parentElement.style.width = "100%";
        konvaJsContext.parentElement.style.height = "100%";
      }
      konvaJsContext.style.width = "100%";
      konvaJsContext.style.height = "100%";
      const konvaJsCanvas = konvaJsContext.getElementsByTagName("canvas")?.[0];
      if (konvaJsCanvas) {
        konvaJsCanvas.style.width = "inherit";
        konvaJsCanvas.style.height = "inherit";
      }
    }
  }, [konvaJsContext]);

  useEffect(() => {
    if (backgroundImage) {
      handlePosition(stageWidth, stageHeight, floorId);
    }
  }, [backgroundImage, stageWidth, stageHeight, floorId, cameraList, top, left, cameraId]);
  // Memoized 4-tier z-order sort — recomputes only when markers or event data changes.
  // Konva renders last item on top, so higher-priority cameras must come last.
  const sortedMarkers = useMemo(
    () =>
      [...(markers || [])].sort((a, b) => {
        // Tier 4: hovered camera — always on top
        const aIsHovered = evidanceSourceId && evidanceSourceId === a?.id;
        const bIsHovered = evidanceSourceId && evidanceSourceId === b?.id;
        if (aIsHovered !== bIsHovered) return aIsHovered ? 1 : -1;
        // Tier 3: live eventIds cameras
        const aInEventIds = eventIds.includes(a?.id);
        const bInEventIds = eventIds.includes(b?.id);
        if (aInEventIds !== bInEventIds) return aInEventIds ? 1 : -1;
        // Both Tier 3 — sub-sort by most recent createdAt so newest icon renders on top
        if (aInEventIds && bInEventIds) {
          const aEvent = eventsallData?.find((e) => e.cameraId === a?.id);
          const bEvent = eventsallData?.find((e) => e.cameraId === b?.id);
          if (aEvent?.createdAt && bEvent?.createdAt) {
            return new Date(aEvent.createdAt) > new Date(bEvent.createdAt) ? 1 : -1;
          }
        }
        // Tier 2: cameraEventsMap cameras (floor-incident count only)
        const aHasMapEvent = !!cameraEventsMap[a?.id];
        const bHasMapEvent = !!cameraEventsMap[b?.id];
        if (aHasMapEvent !== bHasMapEvent) return aHasMapEvent ? 1 : -1;
        return 0;
      }),
    [markers, evidanceSourceId, eventIds, cameraEventsMap, eventsallData]
  );

  const dashboardStageIamge = (fs = false) => {
    const fullscreenWidth = fs ? window.innerWidth * FLOOR_PLAN_CONSTANTS.FULLSCREEN_WIDTH_MULTIPLIER : stageWidth;
    const fullscreenHeight = fs ? window.innerHeight * FLOOR_PLAN_CONSTANTS.FULLSCREEN_HEIGHT_MULTIPLIER : stageHeight;
    return (
      <>
        <Stage
          width={fullscreenWidth}
          height={fullscreenHeight}
          scaleX={scale}
          scaleY={scale}
          ref={stageRef}
          // onWheel={handleWheel}
          // x={widgetSize && markers && !fullScreen ? -markers[0]?.top : 0}
          // y={widgetSize && markers && !fullScreen ? -(markers[0]?.left/1.5) : 0}
          x={0}
          y={0}
          // x={-1482}
          // y={-140}
          Draggable={false}
        >
          <Layer height="100%">
            {backgroundImage && (
              <KonvaImage
                ref={konvaElementRef}
                image={backgroundImage}
                x={0}
                y={0}
                width={backgroundSize.width - FLOOR_PLAN_CONSTANTS.BACKGROUND_SIZE_ADJUSTMENT}
                height={backgroundSize.height - FLOOR_PLAN_CONSTANTS.BACKGROUND_SIZE_ADJUSTMENT}
              />
            )}
            {sortedMarkers.map((marker, index) => {
              if (eventIds.includes(marker?.id) || evidanceSourceId === marker?.id) {
                const isThisHovered = evidanceSourceId === marker?.id;
                // For the hovered camera use the Redux event directly instead of going through
                // handleEventData. handleEventData searches eventsallData by ID which can fail
                // (stale state, multiple events) and fall back to [] → default icon (box).
                // eventObjectDetail is remapped to `custom` to match getEventsIconOnPriorityTile's shape.
                const hoveredEventInfo = isThisHovered && eventNameFetched
                  ? { ...eventNameFetched, custom: eventNameFetched.custom ?? eventNameFetched.eventObjectDetail }
                  : null;
                const eventInfo = eventData ? eventData : hoveredEventInfo || handleEventData(marker?.id);
                const imgSrc = getEventsIconOnPriorityTile(eventInfo, isThisHovered);
                const img = imgSrc ? new window.Image() : null;
                if (img) img.src = imgSrc;
                img.height = "inherit";
                img.width = "inherit";
                img.maxHeight = "inherit";
                img.maxWidth = "inherit";
                return (
                  <React.Fragment key={index}>
                    {/* <Tooltip key={index} title={marker.data} arrow> */}

                    <KonvaImage
                      onClick={() => {
                        if (eventCheck) {
                          const foundCamera = cameras?.find((c) => c.id === marker?.id);
                          if (foundCamera) {
                            navigate(`${ROUTES.CAMERA_INFO_PAGE}?cameraId=${foundCamera.id}`);
                          }
                        } else {
                          handleEventData(marker?.id, dashboard);
                        }
                      }}
                      image={img}
                      x={marker?.top}
                      y={marker?.left}
                      width={foregroundSize.width}
                      height={foregroundSize.height}
                      onMouseEnter={(e) => {
                        handleMouseEnter(e, marker?.data, marker?.top, marker?.left);
                      }}
                      onMouseMove={handleMouseMove}
                      onMouseLeave={(e) => {
                        cancelTooltipTimer();
                        e.target.getStage().container().style.cursor = "default";
                        setTooltipVisible(false);
                        setTooltip({ ...tooltip, visible: false });
                      }}
                      scale={
                        evidanceSourceId === marker?.id
                          ? { x: FLOOR_PLAN_CONSTANTS.SCALE_FACTOR_LARGE, y: FLOOR_PLAN_CONSTANTS.SCALE_FACTOR_LARGE }
                          : { x: FLOOR_PLAN_CONSTANTS.SCALE_FACTOR_NORMAL, y: FLOOR_PLAN_CONSTANTS.SCALE_FACTOR_NORMAL }
                      }
                    />
                    {renderCountBadge(marker?.id, marker?.top, marker?.left, eventInfo?.applicationId, isThisHovered)}
                    {/* </Tooltip> */}
                  </React.Fragment>
                );
              } else {
                if (isEditable && isEditMode) {
                  return (
                    // <Tooltip title={marker.data} arrow>
                    <KonvaImage
                      key={index}
                      image={foregroundImage}
                      x={marker?.top}
                      y={marker?.left}
                      width={foregroundSize.width}
                      height={foregroundSize.height}
                      draggable
                      onDragEnd={(e) => {
                        setPosition({
                          x: e.target.x(),
                          y: e.target.y()
                        });
                        updateMarkerPosition(index, e.target.x(), e.target.y());
                      }}
                    />
                    // </Tooltip>
                  );
                } else {
                  let img = null;
                  if (eventData) {
                    const elseSrc = getEventsIconOnPriorityTile(eventData, evidanceSourceId === marker?.id);
                    if (elseSrc) {
                      img = new window.Image();
                      img.src = elseSrc;
                      img.height = "inherit";
                      img.width = "inherit";
                      img.maxHeight = "inherit";
                      img.maxWidth = "inherit";
                    }
                  }

                  // Pick the idle icon for non-hovered cameras.
                  // Priority: eventData prop (iscamInfo/floorPlan modal) → unresolvedEventData (camera
                  // details page) → live critical event from eventsallData → floor-incident count icon
                  // from cameraEventsMap → plain camera icon.
                  let displayImage = foregroundImage;
                  let iconSource = null;

                  if (eventData && img) {
                    displayImage = img;
                  } else if (iscamInfo && unresolvedEventData) {
                    const unresolvedImg = new window.Image();
                    unresolvedImg.src = getEventsIconOnPriorityTile(unresolvedEventData, false);
                    displayImage = unresolvedImg;
                  } else if (cameraEventsMap[marker?.id]) {
                    // Prefer the live event from eventsallData (has full applicationId/objectType).
                    // Fall back to cameraEventsMap entry (floor-incident count only, no objectType).
                    const realEvent = eventsallData?.find(e => e.cameraId === marker?.id);
                    const mapEntry = cameraEventsMap[marker?.id];
                    iconSource = realEvent || (Array.isArray(mapEntry) ? mapEntry[0] : mapEntry);
                    const criticalImg = new window.Image();
                    criticalImg.src = getEventsIconOnPriorityTile(iconSource, false);
                    criticalImg.height = "inherit";
                    criticalImg.width = "inherit";
                    criticalImg.maxHeight = "inherit";
                    criticalImg.maxWidth = "inherit";
                    displayImage = criticalImg;
                  }
                  return (
                    <React.Fragment key={index}>
                      {/* <Tooltip key={index} title={marker.data} arrow> */}
                      <KonvaImage
                        onClick={() => {
                          // No navigation from camera-details page (iscamInfo) — clicking
                          // a camera icon there would just reload the same page.
                          if (!iscamInfo) handleEventData(marker?.id, false, true);
                        }}
                        image={displayImage}
                        x={marker?.top}
                        y={marker?.left}
                        width={foregroundSize.width}
                        height={foregroundSize.height}
                        listening={true}
                        perfectDrawEnabled={false}
                        onMouseEnter={(e) => {
                          handleMouseEnter(e, marker?.data, marker?.top, marker?.left);
                        }}
                        onMouseMove={handleMouseMove}
                        onMouseLeave={(e) => {
                          cancelTooltipTimer();
                          e.target.getStage().container().style.cursor = "default";
                          setTooltipVisible(false);
                          setTooltip({ ...tooltip, visible: false });
                        }}
                        onDragEnd={(e) => {
                          setPosition({
                            x: e.target.x(),
                            y: e.target.y()
                          });
                        }}
                      />
                      {renderCountBadge(marker?.id, marker?.top, marker?.left, iconSource?.applicationId, evidanceSourceId === marker?.id)}
                      <Rect
                        onClick={() => {
                          // Same guard as KonvaImage above.
                          if (!iscamInfo) handleEventData(marker?.id, false, true);
                        }}
                        x={marker?.top}
                        y={marker?.left}
                        width={foregroundSize.width}
                        height={foregroundSize.height}
                        fill="transparent"
                        listening={true}
                        onMouseEnter={(e) => handleMouseEnter(e, marker?.data, marker?.top, marker?.left)}
                        onMouseMove={handleMouseMove}
                        onMouseLeave={() => {
                          cancelTooltipTimer();
                          setTooltipVisible(false);
                          setTooltip({ ...tooltip, visible: false });
                        }}
                      />
                    </React.Fragment>
                  );
                }
              }
            })}
          </Layer>
        </Stage>
      </>
    );
  };

  const imageModalPopupToggle = () => {
    setModalPopupFullscreen(true);
  };

  useEffect(() => {
    if (modalPopupFullscreen) {
      setBackgroundSize({
        width: window.innerWidth * FLOOR_PLAN_CONSTANTS.FULLSCREEN_WIDTH_MULTIPLIER,
        height: window.innerHeight * FLOOR_PLAN_CONSTANTS.FULLSCREEN_HEIGHT_MULTIPLIER
      });
      // Reset scale to 1 so the floor plan fills the fullscreen modal,
      // matching Dashboard behavior (which never uses fitToContainer).
      SetScale(1);
      if (stageRef.current) {
        stageRef.current.scale({ x: 1, y: 1 });
      }
    } else {
      if (widgetSize) {
        setBackgroundSize({
          width: FLOOR_PLAN_CONSTANTS.DEFAULT_WIDGET_WIDTH,
          height: FLOOR_PLAN_CONSTANTS.DEFAULT_WIDGET_HEIGHT
        });
      }
      // Re-apply fitToContainer scale after modal closes
      if (fitToContainer && stageRef.current) {
        requestAnimationFrame(() => {
          if (!stageRef.current) return;
          const container = stageRef.current.container();
          if (!container) return;
          const width = container.offsetWidth;
          const height = container.offsetHeight;
          if (!width || !height) return;
          const fitScaleX = width / stageWidth;
          const fitScaleY = height / stageHeight;
          const fitScale = Math.min(fitScaleX, fitScaleY, 1);
          stageRef.current.scale({ x: fitScale, y: fitScale });
          SetScale(fitScale);
          stageRef.current.width(width);
          stageRef.current.height(height);
          stageRef.current.batchDraw();
        });
      }
    }
    handlePosition(stageWidth, stageHeight, floorId);
  }, [modalPopupFullscreen]);

  const imageModalPopup = () => {
    return (
      <Modal
        className="dashboard-screenshot"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        disableOutsideClick={true}
        opened={modalPopupFullscreen}
        hideCloseButton={false}
        closeButton={
          <>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                right: `${FLOOR_PLAN_CONSTANTS.MODAL_BUTTON_RIGHT}px`,
                top: `${FLOOR_PLAN_CONSTANTS.MODAL_BUTTON_TOP}px`
              }}
              onClick={() => {
                setModalPopupFullscreen(false);
              }}
            >
              <Icon name="close" />
            </div>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                right: `${FLOOR_PLAN_CONSTANTS.MODAL_BUTTON_RIGHT}px`,
                bottom: `${FLOOR_PLAN_CONSTANTS.MODAL_BUTTON_BOTTOM}px`
              }}
              onClick={() => {
                setModalPopupFullscreen(false);
              }}
            >
              <Icon name="fullscreen-minimize" surface="light" size="large" />
            </div>
          </>
        }
      >
        <ModalBody>
          <div className="dashboard-modal-main">{dashboardStageIamge(true)}</div>
        </ModalBody>
      </Modal>
    );
  };

  const zoomIn = () => {
    const stage = stageRef?.current;
    const oldScale = stage?.scaleX();
    const newScale = oldScale * FLOOR_PLAN_CONSTANTS.ZOOM_IN_FACTOR;
    SetScale(newScale);
  };

  const zoomOut = () => {
    const stage = stageRef?.current;
    const oldScale = stage?.scaleX();
    const newScale = oldScale * FLOOR_PLAN_CONSTANTS.ZOOM_OUT_FACTOR;
    SetScale(newScale);
  };

  const handleEventData = (cameraid, eventInfo = false, cameraIconClicked = false) => {
    const filteredEvents = eventsallData.filter((event) => event.cameraId === cameraid);
    const filteredIconEvent = eventNameFetched?.id 
      ? filteredEvents.find((event) => event.id === eventNameFetched.id)
      : filteredEvents.find((event) => event?.evidences?.some((ev) => ev.id === eventNameFetched?.id));
    if (filteredEvents.length > 0) {
      if (eventInfo) {
        navigate(`/eventsInfo?eventid=${filteredIconEvent?.id || filteredEvents[0]?.id}`);
      } else {
        if (filteredIconEvent !== undefined) {
          return filteredIconEvent;
        } else {
          return filteredEvents[0];
        }
      }
    } else {
      const validCamera = allCameraList?.find((camera) => camera?.id === (cameraid || cameraId));

      if (cameraIconClicked && validCamera?.id) {
        const foundCamera = cameras.find((c) => c.id === cameraid);
        if (foundCamera) {
          navigate(`/cameraInfoPage?cameraId=${foundCamera.id}`);
        }
      }

      return [];
    }
  };

  const onEditClickHandler = () => {
    setShowAdditionalButtons(!showAdditionalButtons);
    setIsEditMode(!isEditMode);
    if (isEditMode) {
      resetMarkers();
    }
  };

  // Shared helper — cancels any pending show-tooltip timeout.
  // Called from all onMouseLeave handlers to prevent the race condition where the
  // deferred setTimeout fires after mouseLeave and leaves the tooltip stuck visible.
  const cancelTooltipTimer = () => {
    if (tooltipTimerRef.current) {
      clearTimeout(tooltipTimerRef.current);
      tooltipTimerRef.current = null;
    }
  };

  const handleMouseEnter = (e, name, markerX, markerY) => {
    const stage = e.target.getStage();
    // Pointer cursor on all camera icons. Suppressed on iscamInfo page — no navigation from there.
    if (!iscamInfo) stage.container().style.cursor = "pointer";
    const pointerPos = stage.getPointerPosition();
    const scale = stage?.scaleX(); // assuming uniform scaling

    // Adjust for scale and stage position
    const localPos = {
      x: (pointerPos.x - stage.x()) / scale,
      y: (pointerPos.y - stage.y()) / scale
    };

    // Position tooltip so it never overlaps the icon.
    // iconRightEdge converts icon's right boundary from Konva canvas coords to CSS screen pixels.
    // Math.max ensures tooltip is always to the right of both the cursor (+4px) and the icon's
    // right edge — so hovering from center never renders tooltip over the icon itself.
    // In fullscreen mode, wrapperStyle applies MODAL_PADDING which offsets the stage canvas inside
    // the container. pointerPos is relative to the stage canvas, so we add the padding back so the
    // tooltip position is correctly relative to the positioned container ancestor.
    const containerOffset = modalPopupFullscreen ? FLOOR_PLAN_CONSTANTS.MODAL_PADDING : 0;
    const iconRightEdge = markerX != null ? (markerX + foregroundSize.width) * scale + stage.x() + containerOffset : pointerPos.x + containerOffset;
    // Clamp to viewport to prevent tooltip from rendering off-screen on right/bottom edges.
    const screenX = Math.min(Math.max(pointerPos.x + containerOffset + 4, iconRightEdge), window.innerWidth - 150);
    const screenY = Math.min(pointerPos.y + containerOffset, window.innerHeight - 50);

    setTooltipText(name);
    cancelTooltipTimer();
    tooltipTimerRef.current = setTimeout(() => {
      setTooltipVisible(true);
      setTooltip({
        visible: true,
        x: screenX,
        y: screenY,
        text: name
      });
      tooltipTimerRef.current = null;
    }, 0);
  };

  const handleMouseMove = (e) => {
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    const scale = stage?.scaleX();

    const localPos = {
      x: (pointerPos.x - stage.x()) / scale,
      y: (pointerPos.y - stage.y()) / scale
    };

    setTooltipPosition({
      x: localPos.x + FLOOR_PLAN_CONSTANTS.TOOLTIP_OFFSET_X,
      y: localPos.y + FLOOR_PLAN_CONSTANTS.TOOLTIP_OFFSET_Y
    });
  };

  const resetMarkers = () => {
    setMarkers(initialMarkers);
  };

  const updateMarkerPosition = (index, x, y) => {
    setMarkers((prevMarkers) => prevMarkers.map((marker, idx) => (idx === index ? { ...marker, left: y, top: x } : marker)));
  };
  useEffect(() => {
    if (isEditable) {
      setIsEditMode(true);
    }
  }, [isEditable]);
  const onCheckMarkClickHandler = async () => {
    const response = await axiosInstance.patch(setDeviceNameEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: { deviceId: cameraList[0].uid },
      device: {
        customdata: {
          cameralocation: {
            top: position.x,
            left: position.y
          }
        }
      }
    });
    if (response.status === 200) {
      setIsEditMode(false);
      setShowAdditionalButtons(false);
    } else if (response.status === 400) {
      console.error();
    }
  };

  const wrapperStyle = modalPopupFullscreen
    ? {
        position: "fixed",
        inset: 0,
        zIndex: FLOOR_PLAN_CONSTANTS.Z_INDEX_MODAL,
        background: "#000",
        top: `${FLOOR_PLAN_CONSTANTS.MODAL_TOP_PERCENT}%`,
        left: `${FLOOR_PLAN_CONSTANTS.MODAL_SIDE_PERCENT}%`,
        right: `${FLOOR_PLAN_CONSTANTS.MODAL_SIDE_PERCENT}%`,
        bottom: `${FLOOR_PLAN_CONSTANTS.MODAL_SIDE_PERCENT}%`,
        margin: "0 auto",
        border: "1px solid #000",
        width: `${FLOOR_PLAN_CONSTANTS.MODAL_WIDTH_PERCENT}%`,
        height: `${FLOOR_PLAN_CONSTANTS.MODAL_HEIGHT_PERCENT}%`,
        padding: `${FLOOR_PLAN_CONSTANTS.MODAL_PADDING}px`,
        overflow: "hidden"
      }
    : { position: "relative", width: "100%", height: "100%" };
  const wrapperStyleBg = modalPopupFullscreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        zIndex: FLOOR_PLAN_CONSTANTS.Z_INDEX_MODAL,
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(15,23,34,0.8)",
        width: "100%",
        height: "100%"
      }
    : { display: "block", width: "100%", height: "100%" };
  const floorPlanOverlay = !imageLoading ? (
    <div style={wrapperStyleBg}>
      <div
        style={wrapperStyle}
              // style={{
              //   width: `100%`,
              //   height: `100%`,
              //   position: "relative",
              // }}
              // <div
              // style={{ width: "100%", height: "100%", position: "relative" }}
              //ref={imageContainerRef} //ref is used to get the height and width of this container
            >
              <>
                {modalPopupFullscreen && (
                  <button
                    className="floor-map-close-button"
                    style={{
                      position: "absolute",
                      top: `${FLOOR_PLAN_CONSTANTS.CLOSE_BUTTON_TOP}px`,
                      right: `${FLOOR_PLAN_CONSTANTS.CLOSE_BUTTON_RIGHT}px`,
                      background: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: `${FLOOR_PLAN_CONSTANTS.CLOSE_BUTTON_SIZE}px`,
                      height: `${FLOOR_PLAN_CONSTANTS.CLOSE_BUTTON_SIZE}px`,
                      fontSize: `${FLOOR_PLAN_CONSTANTS.CLOSE_BUTTON_FONT_SIZE}px`,
                      color: "#333",
                      cursor: "pointer",
                      zIndex: FLOOR_PLAN_CONSTANTS.Z_INDEX_CLOSE_BUTTON,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: `0 2px ${FLOOR_PLAN_CONSTANTS.BOX_SHADOW_BLUR}px rgba(0,0,0,${FLOOR_PLAN_CONSTANTS.BOX_SHADOW_OPACITY})`
                    }}
                    onClick={() => {
                      setModalPopupFullscreen(modalPopupFullscreen ? false : true);
                    }}
                  >
                    &times;
                  </button>
                )}
                {/* {isEditable && (
                  <EditIconForFP>
                    <Edit>
                      <Button onClick={onEditClickHandler}>
                        <Icon name="edit" surface="light" size="large" />
                      </Button>
                    </Edit>
                  </EditIconForFP>
                )}
                {showAdditionalButtons && (
                  <>
                    <TickIconForFP>
                      <Button onClick={onCheckMarkClickHandler}>
                        <Icon name="checkmark" surface="light" size="large" />
                      </Button>
                    </TickIconForFP>

                    <CloseIconForFP>
                      <Button onClick={resetMarkers}>
                        <Icon name="close" surface="light" size="large" />
                      </Button>
                    </CloseIconForFP>
                  </>
                )} */}
                {dashboardStageIamge(false)}
                {/* tooltip.x/y are pre-computed screen pixel coords (not canvas local
                    coords) so the tooltip renders at the icon's right edge regardless of zoom/pan.
                    pointerEvents:none ensures the div never intercepts canvas click events. */}
                {tooltipVisible && !isEditMode && (
                  <div
                    style={{
                      position: "absolute",
                      top: tooltip.y,
                      left: tooltip.x,
                      background: "#333",
                      color: "#fff",
                      padding: `${FLOOR_PLAN_CONSTANTS.TOOLTIP_PADDING}px 10px`,
                      borderRadius: `${FLOOR_PLAN_CONSTANTS.TOOLTIP_BORDER_RADIUS}px`,
                      fontSize: `${FLOOR_PLAN_CONSTANTS.TOOLTIP_FONT_SIZE}px`,
                      pointerEvents: "none"
                    }}
                  >
                    <span>{tooltip.text}</span>
                  </div>
                )}
                {!isEditMode && !modalPopupFullscreen && !tooltipVisible && (
                  <MapControls style={{ paddingRight: `${iscamInfo ? `${FLOOR_PLAN_CONSTANTS.CAMERA_INFO_PADDING}px` : "0px"}` }}>
                    <ZoomButtonsBox>
                      <Button
                        onClick={() => {
                          zoomIn();
                        }}
                      >
                        <Icon name="zoom-in" surface="light" size="large" />
                      </Button>
                      <Button
                        onClick={() => {
                          zoomOut();
                        }}
                      >
                        <Icon name="zoom-out" surface="light" size="large" />
                      </Button>
                    </ZoomButtonsBox>
                    <Expand>
                      <Button
                        onClick={() => {
                          setModalPopupFullscreen(modalPopupFullscreen ? false : true);
                        }}
                      >
                        <Icon name="fullscreen" surface="light" size="large" />
                      </Button>
                    </Expand>
                  </MapControls>
                )}
              </>
            </div>
    </div>
  ) : null;
  return (
    <>
      <Container>
        {imageLoading && <Loader fullscreen={false} active={true} surface="light" />}
        {!imageLoading && (
          modalPopupFullscreen
            ? createPortal(floorPlanOverlay, document.body)
            : floorPlanOverlay
        )}
      </Container>
    </>
  );
};

export default FloorPlan;
